export const getChain = state => state.navigation.chain;
export const getPrevUrl = state => state.navigation.prevUrl;
